import { Box, Typography } from '@material-ui/core';

export default function FooterComponent() {
    return (
          <Box m={4}>
              <Typography variant="body1" align="center">
                © 2023 VIOSO GmbH<br />
		Version 1.5 (20231203)
              </Typography>
          </Box>
    )
}
